import * as React from "react"

const Capture = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 66.24" {...props}>
    <title>{"parcel-journey-9-driver-capture-icon-2"}</title>
    <path
      d="M29.37 48.09H6.63l3.77-4.78H14v2.41h8v-2.41h3.6ZM14 42.36h-3.79v-1h.57v-22h-.57v-1.45h15.48v1.44h-.57v22h.57v1H22v-4.6h-8Zm-1.09-9.9a.85.85 0 0 0 .08-1.2.6.6 0 0 0-.08-.08v-.43h-1.12v.43a.85.85 0 0 0-.08 1.2l.08.08v2.16h1.14Zm7 8.18h-3.84V41h3.87Zm-3.71-2.23h-1.6v.36h1.6Zm3.71 3.05h-3.84v.36h3.87Zm0 .82h-3.84v.36h3.87ZM37 57.49V8.75A8.75 8.75 0 0 0 28.25 0H8.75A8.75 8.75 0 0 0 0 8.75v48.74a8.75 8.75 0 0 0 8.75 8.75h19.5A8.75 8.75 0 0 0 37 57.49Zm-4.77 0H4.38V9h27.85ZM24.48 4.77a.63.63 0 0 1-.63.63h-11.1a.63.63 0 0 1-.63-.63.63.63 0 0 1 .63-.63h11.1a.63.63 0 0 1 .63.63Z"
      fill="#4ead90"
    />
  </svg>
)

export default Capture
